class CartItem extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.key = this.dataset.id;
    this.qtyInput = this.querySelector(".cart-item__qty-input");

    this.addEventListener("click", (event) => {
      const button = event.target.closest("button");
      // if (!button) return;
      const value = parseInt(this.qtyInput.value);

      if (button.name === "plus") {
        event.preventDefault();
        this.qtyInput.value = parseInt(value) + 1;
        button.closest("form").submit();
      } else if (button.name === "minus") {
        event.preventDefault();
        if (value > 1) {
          this.qtyInput.value = parseInt(value) - 1;
          button.closest("form").submit();
        } else if (value === 1) {
          event.preventDefault();
          this.qtyInput.value = 0;
          this.closest("form").submit();
        }
      }
    });

    if (this.qtyInput) {
      this.qtyInput.addEventListener("change", () => {
        event.preventDefault();
        this.closest("form").submit();
      });
    }
  }
}

if (!customElements.get("cart-item")) {
  customElements.define("cart-item", CartItem);
}

document.addEventListener("DOMContentLoaded", () => {
  const selectAllCheckbox = document.getElementById("selectAllCheckbox");
  const deleteSelectedBtn = document.getElementById("deleteSelectedBtn");
  const itemCheckboxes = document.querySelectorAll(".item-select-checkbox");

  function updateDeleteButtonVisibility() {
    const anyChecked = Array.from(itemCheckboxes).some((cb) => cb.checked);
    if (deleteSelectedBtn) {
      deleteSelectedBtn.style.display = anyChecked ? "inline-block" : "none";
    }

    // Update select all checkbox state
    if (selectAllCheckbox && itemCheckboxes.length > 0) {
      const allChecked = Array.from(itemCheckboxes).every((cb) => cb.checked);
      selectAllCheckbox.checked = allChecked;
    }
  }

  if (selectAllCheckbox) {
    selectAllCheckbox.addEventListener("change", (e) => {
      const isChecked = e.target.checked;
      itemCheckboxes.forEach((cb) => {
        cb.checked = isChecked;
      });
      updateDeleteButtonVisibility();
    });
  }

  itemCheckboxes.forEach((cb) => {
    cb.addEventListener("change", updateDeleteButtonVisibility);
  });

  if (deleteSelectedBtn) {
    deleteSelectedBtn.addEventListener("click", () => {
      const updates = {};
      itemCheckboxes.forEach((cb) => {
        if (cb.checked) {
          const cartItem = cb.closest("cart-item");
          if (cartItem && cartItem.dataset.id) {
            updates[cartItem.dataset.id] = 0;
          }
        }
      });

      if (Object.keys(updates).length > 0) {
        deleteSelectedBtn.disabled = true;
        deleteSelectedBtn.querySelector(".button__inner").textContent =
          "Deleting...";

        fetch(window.Shopify.routes.root + "cart/update.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ updates }),
        })
          .then((response) => response.json())
          .then(() => {
            location.reload();
          })
          .catch((error) => {
            console.error("Error updating cart:", error);
            deleteSelectedBtn.disabled = false;
            deleteSelectedBtn.querySelector(".button__inner").textContent =
              "Delete Selected";
          });
      }
    });
  }
});
